import { useContext } from "react";
import Icon from "../Icon/Icon";
import styles from "./dropdownMenu.css";
import { DropdownMenuContext } from "./DropdownMenuContext.jsx";

function DropdownMenuItem({ icon, onClick, children }) {
  const { setOpen } = useContext(DropdownMenuContext);

  function handleClick(e) {
    setOpen(false);
    onClick && onClick(e);
  }

  return (
    <li className={styles.dropdownMenuListItem}>
      <button
        type="button"
        className={styles.dropdownMenuItem}
        onClick={handleClick}
      >
        {icon && <Icon name={icon} size="16px" />}

        {children}
      </button>
    </li>
  );
}

export default DropdownMenuItem;
